<script>
export default {

  name: 'UtilsMixin',

  methods: {
    padTo2Digits (num) {
      return num.toString().padStart(2, '0')
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      try {
        return [
          date.getFullYear(),
          this.padTo2Digits(date.getMonth() + 1),
          this.padTo2Digits(date.getDate()),
        ].join('-')
      }
      catch (e) {
        return date
      }
    },
    humanizeDate (djangoDate) {
      var jsDate = new Date(djangoDate)

      return [
        this.padTo2Digits(jsDate.getDate()),
        this.padTo2Digits(jsDate.getMonth() + 1),
        jsDate.getFullYear()
      ].join('.')
    }
  }
}
</script>
